// Text for the 'pizza' world: its name on the map, the level titles and the comic word in the scene, per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Pizzafabrik',
    scene: { yum: 'NAM!' },
    levels: {
      'gear': { title: 'Tandhjulet' },
      'other-way': { title: 'Den anden vej' },
      'dough-roller': { title: 'Dejvalsen' },
      'left-or-right': { title: 'Højre eller venstre' },
      'reversed': { title: 'Omvendt' },
      'fast-belt': { title: 'Hurtigt bånd' },
      'slow-belt': { title: 'Langsomt bånd' },
      'two-wheels': { title: 'To hjul' },
      'big-jump': { title: 'Stort spring' },
      'roller-turns': { title: 'Valsen vender' },
      'stuck': { title: 'Fastlåst' },
      'oven': { title: 'Ovnen' },
      'over-the-wall': { title: 'Over muren' },
      'dough-lump': { title: 'Dejklumpen' },
      'pizza-master': { title: 'Pizzamester' },
    },
  },
  en: {
    name: 'Pizza factory',
    scene: { yum: 'YUM!' },
    levels: {
      'gear': { title: 'The cog' },
      'other-way': { title: 'The other way' },
      'dough-roller': { title: 'The dough roller' },
      'left-or-right': { title: 'Right or left' },
      'reversed': { title: 'Reversed' },
      'fast-belt': { title: 'Fast belt' },
      'slow-belt': { title: 'Slow belt' },
      'two-wheels': { title: 'Two wheels' },
      'big-jump': { title: 'Big jump' },
      'roller-turns': { title: 'The roller turns' },
      'stuck': { title: 'Stuck' },
      'oven': { title: 'The oven' },
      'over-the-wall': { title: 'Over the wall' },
      'dough-lump': { title: 'The lump of dough' },
      'pizza-master': { title: 'Pizza master' },
    },
  },
});
